import React, { useContext, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import Axios from "axios";
import { StateContext } from "../App";
import "./login.css";

function Login(props) {
  const [error, setError] = useState("");

  // console.log("Login component!", props);
  const { dispatch } = useContext(StateContext);

  const login_form = async (e) => {
    e.preventDefault();
    const notLoadingBtn =  document.querySelector(".not-loading-btn")
    const isLoadingBtn = document.querySelector(".btn-back")
    
    notLoadingBtn.style.display = "none";
    isLoadingBtn.style.display = "block";

    setError("")

    const form = document.querySelector(".login-form");

    const email = form.email.value;
    const password = form.password.value;

    try {
      const result = await Axios.post("/login", { email, password });
      // result && console.log("the axios request result", result.data.user);
      /* result &&
        console.log("the Error axios request result", result.data.error); */

      // check for user and set to the state with auth!
      if (result.data.user) {
        // document.querySelector(".not-loading-btn").style.display = "block";
        // document.querySelector(".btn-back").style.display = "none";
        
        dispatch({ type: "SET_AUTH", payload: true });
        localStorage.setItem("user", JSON.stringify(result.data.user._id));

        // console.log("Testing the role", result.data.user)
        
        setTimeout(() => {
          if (result.data.user.role === "admin") {
            props.history.push("/admin-dashboard/customers");
          }
          else {
            props.history.push("/dashboard/overview");
          }
        }, 1000)

        
      }
      if (result.data.error) {
        document.querySelector(".not-loading-btn").style.display = "block";
        document.querySelector(".btn-back").style.display = "none";
        dispatch({ type: "SET_AUTH", payload: false });
        // form.email.value = "";
        // form.password.value = "";
        setError(result.data.error);
      }
    } catch (err) {
       notLoadingBtn.style.display = "block";
       isLoadingBtn.style.display = "none";
      dispatch({ type: "SET_AUTH", payload: false });
    }
  };

  return (
    <div className="login">
      <div className="centered">
        <form className="login-form" onSubmit={login_form}>
          <h3>login</h3>
          <span className="error">{error}</span>
          {/* username OR email */}
          <div className="input-field">
            <input className="email-input" type="text" name="email" placeholder="Enter your email" />
          </div>
          {/* Password */}
          <div className="input-field">
            <input
              className="password-input"
              required
              type="password"
              name="password"
              placeholder="Enter your password"
            />
          </div>
          <div className="input-field">
            <button className="not-loading-btn">login</button>
            <div className="btn-back">
              <button disabled className="loading-btn">
                <div id="loader"></div>
              </button>
            </div>
          </div>
          <div className="action-btn align-center">
            {/* <span>forgot password?</span> */}
            <Link to="/forgot-password">forgot password?</Link>
          </div>
          <div className="action-btn">
            <span>don't have an account?</span>
            <Link to="/signup">signup</Link>
          </div>
        </form>
      </div>
      <div className="homepage-link">
        <a href="/">go to homepage</a>
      </div>
    </div>
  );
}

export default withRouter(Login);
